import { PixTransactionStatus, PixTransactionType } from 'types';

export const TYPES_OPTIONS: Array<{
  label: string;
  value: PixTransactionType;
}> = [
  { label: 'Pagamento', value: 'PAYMENT' },
  { label: 'Estorno', value: 'REFUND' },
  { label: 'Transferência', value: 'TRANSFER' },
];

export const STATUS_OPTIONS: Array<{
  label: string;
  value: PixTransactionStatus;
}> = [
  { label: 'Aguardando confirmação', value: 'WAITING_FOR_CONFIRMATION' },
  { label: 'Aguardando transferência', value: 'AVAILABLE_TRANSACTION' },
  { label: 'Transferência realizada', value: 'CONFIRMED_TRANSACTION' },
  { label: 'Aguardando estorno', value: 'WAITING_FOR_REFUND' },
  { label: 'Transferência cancelada', value: 'CANCELLED_TRANSACTION' },
  { label: 'Falha na transferência', value: 'TRANSACTION_ERROR' },
  { label: 'Processada', value: 'ACCEPTED' },
  { label: 'Falha', value: 'ERROR' },
];

export const WALLET_OPTIONS = [
  { label: 'Cliente', value: 'CUSTOMER_WALLET' },
  { label: 'Wallet Pix', value: 'PIX_WALLET' },
  { label: 'Wallet Matriz', value: 'MASTER_WALLET' },
  { label: 'Indefinido(a)', value: 'UNDEFINED_WALLET' },
  { label: 'Web', value: 'WEB_WALLET' },
  { label: 'Frete', value: 'DELIVERY_COST_WALLET' },
];
